(function() {

	angular
		.module('ngmvac')
		.directive('bsModal', Modal);

	function Modal() {
		return {
			template: [
				'<div class="modal fade" tabindex="-1" rol="dialog">',
					'<div class="modal-dialog modal-lg" role="document">',
						'<div class="modal-content">',
							'<div class="modal-header">',
								'<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>',
								'<h4 class="modal-title">{{title}}</h4>',
							'</div>',
							'<div class="modal-body" ng-transclude></div>',
						'</div>',
					'</div>',
				'</div>'
			].join(''),
			restrict: 'E',
			transclude: true,
			replace: true,
			scope: {
				visible: '=',
				onSown: '&',
				onHide: '&',
				title: '@'
			},
			link: function postLink(scope, element, attrs) {

				$(element).modal({
					show: false,
				});

				scope.$watch(
					function() {
						return scope.visible
					},
					function(value) {
						if( value == true ) {
							$(element).modal('show');
						} else {
							$(element).modal('hide');
						}
					}
				);

				$(element).on('shown.bs.modal', function(){
                  	scope.$apply(function(){
                      	scope.onSown({});
                  	});
                });

                $(element).on('hidden.bs.modal', function(){
					scope.visible = false;
                });

                $(element).on('hidden.bs.modal', function(){
                  	scope.$apply(function(){
                      	scope.onHide({});
                  	});
                });

			}
		}
	}

})();
